import { render, staticRenderFns } from "./SuperDash.vue?vue&type=template&id=52db69cf&scoped=true"
import script from "./SuperDash.vue?vue&type=script&lang=js"
export * from "./SuperDash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52db69cf",
  null
  
)

export default component.exports